import { canEncode, code128Widths } from '../utils/code128'

// A Code 128 barcode as an SVG that scales to its box. `quiet` is the blank
// margin (in bar widths) scanners need on each side.
export default function Barcode({ value, className, quiet = 10, title }) {
  if (!canEncode(value)) return <span className={className}>No barcode</span>
  const widths = code128Widths(value)
  const total = widths.reduce((s, w) => s + w, 0) + quiet * 2
  const bars = []
  let x = quiet
  widths.forEach((w, i) => {
    if (i % 2 === 0) bars.push(<rect key={i} x={x} y={0} width={w} height={1} />)
    x += w
  })
  return (
    <svg className={className} viewBox={`0 0 ${total} 1`} preserveAspectRatio="none" shapeRendering="crispEdges" role="img" aria-label={title || `Barcode ${value}`}>
      <rect x={0} y={0} width={total} height={1} fill="#fff" />
      <g fill="#000">{bars}</g>
    </svg>
  )
}
